import * as cssInput from '../../classes/input';
import * as cssDisabledInput from './DisabledInput.css';

const css= {...cssDisabledInput,...cssInput};

function DisabledInput({value, icon, text = '', className, children, description = '',events ,dataCyName, hasArrow, invalid = false}) {
    const hasIcon=icon!==false;
    const inputClass = (className || '') + ' input ' + (hasArrow ? 'hasArrow' : '');
    const containerClass = invalid ? 'invalid' : '';

    return (
        <css.container {...events} className={containerClass} data-cy={`${dataCyName ? dataCyName: 'default'}Input`}>
            {hasIcon&&<css.icon icon={icon}/>}
            <css.wrap>{children ?
                <css.disabledInput className={inputClass}>{children}</css.disabledInput>
                :
                <css.disabledInput className={inputClass} >{value}</css.disabledInput>
            }
            <css.title>{text}&nbsp;<span>{description}</span></css.title>
            </css.wrap>
        </css.container>
    );
}
export default DisabledInput;
